
import type { App } from 'vue'
import component from './PrintTools.vue'

const install = (app: App): void => {
	app.component(component.name, component)
}

export default {
	install,
	component
}

